import React, { useEffect, useMemo, useState } from "react"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Button,
} from "reactstrap"

import { Link, useNavigate, useParams } from "react-router-dom"
import leftArrow from "../../../assets/images/icons/left-arrow.svg"
import RequestRejectConfirmationModal from "./requestRejectConfirmation"
import RequestApproveConfirmationModal from "./requestApproveConfirmation"
import {
  useGetProfileUpdateRequestsApproveMutation,
  useGetProfileUpdateRequestsRejectMutation,
  useLazyGetProfileUpdateRequestsViewQuery,
} from "store/api/profile/profile.api"
import IndividualView from "./individualView"
import NonIndividualView from "./nonIndividualView"
import { usePermission } from "hooks/usePermission"
import { PERMISSIONS } from "helpers/roles"
import { useSelector } from "react-redux"
import Breadcrumb from "components/Common/Breadcrumb"

const ViewInvestorsProfileRequest = ({ type = null }) => {
  const { id } = useParams()
  const history = useNavigate()
  const [getResult, { isFetching }] = useLazyGetProfileUpdateRequestsViewQuery()
  const [requestData, setRequestData] = useState(null)
  const [isToast, setIsToast] = useState(false)
  const [actionType, setActionType] = useState() //APPROVE,REJECT
  const { hasPermission } = usePermission()
  const { userType } = useSelector((state) => state.user)

  const [onApprove, { isLoading: isApproving }] =
    useGetProfileUpdateRequestsApproveMutation()
  const [onReject, { isLoading: isRejecting }] =
    useGetProfileUpdateRequestsRejectMutation()

  useEffect(() => {
    if (id) {
      getRequestData()
    }
  }, [id, type])

  const getRequestData = async () => {
    try {
      const params = { id }
      if (type) params["type"] = type
      const { data } = await getResult(params).unwrap()
      setRequestData(data)
    } catch (error) {
      if (error.status === 404) {
        history(
          userType === "ADMIN"
            ? `/${
                type === "INVESTOR" ? "investors" : "wealth-partners"
              }/profile-updates`
            : `/profile/updates/`
        )
      }
    }
  }

  document.title = "Request Details  | Prachay"

  const canAction = useMemo(() => {
    if (type === "INVESTOR") return hasPermission(PERMISSIONS.INVESTOR_UPDATE)
    else return hasPermission(PERMISSIONS.WEALTH_PARTNER_UPDATE)
  }, [hasPermission, type])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title={"Request Details"} />
          <Row>
            <Col xl={12}>
              <Card>
                <CardBody>
                  {requestData &&
                    (requestData?.investor?.entity_type === "INDIVIDUAL" ||
                      requestData?.wealthPartner?.entity_type ===
                        "INDIVIDUAL") && (
                      <IndividualView profileData={requestData} />
                    )}
                  {requestData &&
                    (requestData?.investor?.entity_type === "COMPANY" ||
                      requestData?.wealthPartner?.entity_type ===
                        "COMPANY") && (
                      <NonIndividualView profileData={requestData} />
                    )}
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col xl={12}>
              {requestData?.status === "SUBMITTED" &&
                canAction &&
                userType === "ADMIN" && (
                  <>
                    <div className="buttons button-wrapper buttons">
                      <Button
                        className="reject"
                        onClick={() => {
                          setIsToast(true)
                          setActionType("REJECT")
                        }}
                      >
                        Reject
                      </Button>
                      <Button
                        className="approve"
                        onClick={() => {
                          setIsToast(true)
                          setActionType("APPROVE")
                        }}
                      >
                        Approve
                      </Button>
                    </div>

                    {requestData && isToast && actionType === "APPROVE" && (
                      <RequestApproveConfirmationModal
                        open={isToast}
                        id={requestData.id}
                        setOpen={setIsToast}
                        isLoading={isApproving}
                        title="Approve Updates"
                        description="Are you sure you want to approve updates?"
                        onClose={() => {
                          setIsToast(false)
                          setActionType("")
                        }}
                        onApprove={onApprove}
                        onSuccess={() =>
                          history(
                            `/${
                              type === "INVESTOR"
                                ? "investors"
                                : "wealth-partners"
                            }/profile-updates`
                          )
                        }
                      />
                    )}

                    {requestData && isToast && actionType === "REJECT" && (
                      <RequestRejectConfirmationModal
                        open={isToast}
                        id={requestData.id}
                        setOpen={setIsToast}
                        isLoading={isRejecting}
                        title="Reject Updates"
                        description="Are you sure you want to reject updates?"
                        onClose={() => {
                          setIsToast(false)
                          setActionType("")
                        }}
                        onReject={onReject}
                        onSuccess={() =>
                          history(
                            `/${
                              type === "INVESTOR"
                                ? "investors"
                                : "wealth-partners"
                            }/profile-updates`
                          )
                        }
                      />
                    )}
                  </>
                )}
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ViewInvestorsProfileRequest
